export class AddUserPermissionsFailure {
    static readonly type = '[User] AddUserPermissionsFailure';
}
